import React from "react";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";

const Footer = () => (
  <footer className="bg-stone-900 text-stone-300 mt-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Globe className="w-5 h-5 text-[#C2410C]" />
          <span className="font-serif text-2xl font-semibold text-white">UMoooV</span>
        </div>
        <p className="text-sm text-stone-400 max-w-xs leading-relaxed">
          Professionally structured relocation guides for the world's most sought-after destinations. Move abroad with clarity.
        </p>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-widest text-stone-500 mb-4">Destinations</h4>
        <ul className="space-y-2 text-sm">
          {["Italy", "France", "Spain", "Germany", "Sweden", "UAE", "Portugal", "United States", "Canada"].map((c) => (
            <li key={c}><Link to="/" className="hover:text-white transition-colors">{c}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-widest text-stone-500 mb-4">Important</h4>
        <p className="text-xs text-stone-400 leading-relaxed">
          Guides are informational drafts, not legal, tax, or immigration advice. Visa and tax rules change frequently — always verify with official sources and qualified professionals. Each guide shows a "last updated" date.
        </p>
      </div>
    </div>
    <div className="border-t border-stone-800 py-6 text-center text-xs text-stone-500">
      © {new Date().getFullYear()} UMoooV. All rights reserved.
    </div>
  </footer>
);

export default Footer;
